import React, { useState } from 'react';
import ReactModal from 'react-modal';
import Autocomplete from 'react-google-autocomplete';
import Aux from '../../../../hoc/ReactAux/ReactAux';
import logo from 'images/logo-lunch-team.svg';

import './index.css';

const customStyles = {
  content: {
    background: 'none',
    border: 'none',
  },
  overlay: {
    zIndex: '9999999',
    width: '100%',
    height: '100%',
    left: '0',
    top: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
};

const disable = {
  background: 'white',
  color: '#ff5007',
  border: '1px solid #ff5007',
  cursor: 'not-allowed',
};

const OptionsForDelivery = ({
  listAddress,
  selectOptionForOrder,
  showCollectionOption,
  showDeliverAtHomeOption,
  handleSearchNewDeliveryAddress,
  onFetchingMenu,
  idBusiness,
  onToggleCart,
  onDeleteAllproductsFromCard,
  onCartResetState,
  onDeleteRestaurantSelected,
  onFetchingRecentlyOrdered,
}) => {
  const onClickOptionsForDelivery = address => {
    localStorage.setItem('idBusinessAddress', address.idBusinessAddress);
    selectOptionForOrder(address);
    onToggleCart();
    onDeleteAllproductsFromCard();
    onFetchingMenu(idBusiness, address.idBusinessAddress);
    onCartResetState();
    onDeleteRestaurantSelected();
    onFetchingRecentlyOrdered(address.idBusinessAddress);
  };

  return (
    <Aux>
      {listAddress.map(address =>
        !address.forCollection ||
        (address.forCollection && showCollectionOption) ? (
          <Aux
            key={
              address.idBusinessAddress == null
                ? address.idCustomerDeliveryAddress
                : address.idBusinessAddress
            }
          >
            <button
              onClick={() => onClickOptionsForDelivery(address)}
              className="btn orange-bold"
            >
              {address.street}
            </button>
          </Aux>
        ) : null
      )}
      {showDeliverAtHomeOption ? (
        <button
          onClick={() => handleSearchNewDeliveryAddress()}
          className="btn orange-bold"
        >
          Deliver @ HOME
        </button>
      ) : null}
    </Aux>
  );
};

const LocationSearchInput = ({
  place,
  handleSetAddress,
  handleSaveAddress,
  handleBackToAddressList,
}) => {
  return (
    <Aux>
      <br></br>
      <Autocomplete
        onPlaceSelected={place => {
          handleSetAddress(place);
        }}
        componentRestrictions={{ country: 'ie' }}
        types={['address']}
      />
      <button
        onClick={e => handleSaveAddress()}
        style={place === '' || place == null ? disable : null}
        className="btn orange-bold"
      >
        {place === '' || place == null ? 'Find your address' : `Save ${place}`}
      </button>
      <button
        onClick={e => handleBackToAddressList()}
        className="btn orange-bold"
      >
        Back to address list
      </button>
    </Aux>
  );
};

const OptionsForDeliveryOrCollectionOrder = ({
  showModal,
  listAddress,
  showCollectionOption,
  showDeliverAtHomeOption,
  selectOptionForOrder,
  createCustomerDeliveryAddress,
  onFetchingMenu,
  idBusiness,
  onToggleCart,
  onDeleteAllproductsFromCard,
  onCartResetState,
  onDeleteRestaurantSelected,
  onFetchingRecentlyOrdered,
}) => {
  const [search, setSearch] = useState(false);
  const [place, setPlace] = useState('');
  const [fullPlace, setFullPlace] = useState([]);

  if (!showModal) {
    return null;
  }

  const onHandleSearchNewDeliveryAddress = () => {
    setSearch(true);
    showModal = false;
  };

  const onHandleBackToAddressList = () => {
    setSearch(false);
  };

  const onHandleSetAddress = place => {
    setPlace(place.formatted_address);
    setFullPlace(place);
  };

  const onHandleSaveAddress = () => {
    createCustomerDeliveryAddress(getAddressInfoObject());
  };

  const getAddressInfoObject = () => {
    return {
      formattedAddress: fullPlace.formatted_address,
      placeId: fullPlace.place_id,
      lat: fullPlace.geometry.location.lat(),
      lng: fullPlace.geometry.location.lng(),
    };
  };

  return (
    <Aux>
      <ReactModal
        isOpen={showModal}
        style={customStyles}
        className="content-react-modal"
        contentLabel="Order for Modal"
      >
        <div
          id="login3"
          className="mfp-bg-login white-popup-block lb-centralizar singup zoom-anim-dialog"
        >
          <div className="modal-content">
            <img
              style={{
                display: 'block',
                margin: '0 auto',
                paddingBottom: '80px',
              }}
              src={logo}
              alt="Lunch Team"
            />
            <h3 className="b">Order for</h3>
            <div
              style={{
                maxHeight:
                  document.documentElement.clientHeight > 900
                    ? '600px'
                    : '300px',
                overflowY: 'scroll',
                paddingRight: '8px',
                marginRight: '-10px',
              }}
            >
              {!search ? (
                <OptionsForDelivery
                  idBusiness={idBusiness}
                  onToggleCart={onToggleCart}
                  onDeleteAllproductsFromCard={onDeleteAllproductsFromCard}
                  onFetchingMenu={onFetchingMenu}
                  listAddress={listAddress}
                  selectOptionForOrder={selectOptionForOrder}
                  showCollectionOption={showCollectionOption}
                  showDeliverAtHomeOption={showDeliverAtHomeOption}
                  handleSearchNewDeliveryAddress={
                    onHandleSearchNewDeliveryAddress
                  }
                  onCartResetState={onCartResetState}
                  onDeleteRestaurantSelected={onDeleteRestaurantSelected}
                  onFetchingRecentlyOrdered={onFetchingRecentlyOrdered}
                />
              ) : (
                <LocationSearchInput
                  handleSetAddress={onHandleSetAddress}
                  handleSaveAddress={onHandleSaveAddress}
                  handleBackToAddressList={onHandleBackToAddressList}
                  place={place}
                />
              )}
            </div>
          </div>
        </div>
      </ReactModal>
    </Aux>
  );
};

export default OptionsForDeliveryOrCollectionOrder;



// WEBPACK FOOTER //
// ./src/containers/Menu/DefaultMenu/OptionsForOrder/index.js